import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPosCompany } from '../models/models'

export class ListPosCompanyApi extends ClientProxy {
  private readonly baseUrl = 'admin/posTransaction/listPosCompany'

  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransaction/listPosCompany',
      requesterInfo,
    })
  }

  public async listPosCompany(): Promise<IPosCompany[]> {
    this.props.url = this.baseUrl
    return await this.getAsync<IPosCompany[]>()
  }

  public async listPosCompanyByCompanyId(companyId: number): Promise<IPosCompany[]> {
    this.props.url = `${this.baseUrl}/${companyId}`
    return await this.getAsync<IPosCompany[]>()
  }
}